import type { FaireProductEntity } from "../../entity_types/product";

export const p_beafaxh6kz: FaireProductEntity = {
  token: "p_beafaxh6kz",
  type: "product",
  name: "Campfire S'more Summer Soy Wax Candle Scented Rustic Candles",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/b98df65f3d2374fc9d5b397748de82d5f924e23673bbbb93af5c940f35609b6b.jpeg",
  priceDollars: 9.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/92d772461b621d46b78bd7b902229ec5ea327f5abc53ba459e2b6a406e3ae1ea.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
